export const secuencia = [
  {value: 1, label: 'REGISTRO_ALIMENTACION'},
  {value: 2, label: 'REGISTRO_INTERVENCION_SANITARIA'},
  {value: 3, label: 'PEDIDO'},
  {value: 4, label: 'ALBARAN'},
  {value: 5, label: 'POOL'}
]
